import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Button, Card, CardBody, CardFooter, CardHeader, Col, FormGroup, Input, Label, Row } from "reactstrap";
import CertificateSeriesProductSearch from "./CertificateSeriesProductSearch";
import { useService } from "../../context/ServiceContext";
import CertificateSeriesProductSearchResults from "./CertificateSeriesProductSearch";
import { ExistingCertificateSummary } from "../../views/Certificates/Edit";

function CertificateProductSelection({ history, cloneData, existingCertificate }) {
  const intl = useIntl();
  const { certificateStore, certificatePreview, certificateUpdate } = useService();

  const [name, setName] = useState("");
  const [typeOfCertificate, setTypeOfCertificate] = useState(13);
  const [isUKCA, setIsUKCA] = useState(false);

  const { certificateManufacturersProvider } = useService();
  const [companies, setCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [submittedSearch, setSubmittedSearch] = useState(null);
  const [submittedCompany, setSubmittedCompany] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState("");

  const [validationCheck, setValidationCheck] = useState(false);

  useEffect(() => {
    async function getData() {
      try {
        const companies = await certificateManufacturersProvider.get();
        setCompanies(companies);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    }
    getData();
  }, []);

  async function previewCertificate(dataPackage) {
    if (!isValid()) return;

    const formData = new FormData();
    formData.append("Name", name);
    formData.append("KeyCompany", dataPackage.keyCompany);
    formData.append("CustomType", dataPackage.customType);
    formData.append("Series", JSON.stringify(dataPackage.series ?? []));
    formData.append("Products", JSON.stringify(dataPackage.products ?? []));
    formData.append("Legislations", JSON.stringify(dataPackage.legislations ?? []));
    formData.append("Regulations", JSON.stringify(dataPackage.regulations ?? []));
    formData.append("TypeOfCertificate", typeOfCertificate);
    formData.append("IsUKCA", isUKCA);
    formData.append("StartDate", new Date(dataPackage.startDate).toISOString());
    formData.append("EndDate", dataPackage.endDate == "" ? "" : new Date(dataPackage.endDate).toISOString());
    formData.append("Notes", dataPackage.notes);

    return await certificatePreview.store(formData, { "Content-Type": "multipart/form-data" });
  }

  async function updateCertificate(dataPackage) {
    const formData = new FormData();
    dataPackage.files.forEach((file) => {
      formData.append("Files", file);
    });
    formData.append("Legislations", JSON.stringify(dataPackage.legislations ?? []));
    formData.append("Regulations", JSON.stringify(dataPackage.regulations ?? []));
    formData.append("StartDate", new Date(dataPackage.startDate).toISOString());
    formData.append("EndDate", dataPackage.endDate == "" ? "" : new Date(dataPackage.endDate).toISOString());
    formData.append("ClonedUploads", dataPackage.clonedUploads != null ? JSON.stringify(dataPackage.clonedUploads) : null);
    formData.append("Notes", dataPackage.notes);
    formData.append("DocumentClass", existingCertificate.documentClass);
    formData.append("DocumentReference", existingCertificate.documentReference);
    formData.append("KeyCompany", existingCertificate.company);
    formData.append("Series", existingCertificate.series);
    formData.append("Language", existingCertificate.languageId);
    formData.append("TypeOfCertificate", existingCertificate.idTipoDocumental);

    await certificateUpdate.store(formData, { "Content-Type": "multipart/form-data" });
  }

  async function saveCertificate(dataPackage) {
    if (!isValid()) return;

    const formData = new FormData();
    dataPackage.files.forEach((file) => {
      formData.append("Files", file);
    });
    formData.append("Name", name);
    formData.append("KeyCompany", dataPackage.keyCompany);
    formData.append("CustomType", dataPackage.customType);
    formData.append("Series", JSON.stringify(dataPackage.series ?? []));
    formData.append("Products", JSON.stringify(dataPackage.products ?? []));
    formData.append("Legislations", JSON.stringify(dataPackage.legislations ?? []));
    formData.append("Regulations", JSON.stringify(dataPackage.regulations ?? []));
    formData.append("TypeOfCertificate", typeOfCertificate);
    formData.append("IsUKCA", isUKCA);
    formData.append("StartDate", new Date(dataPackage.startDate).toISOString());
    formData.append("EndDate", dataPackage.endDate == "" ? "" : new Date(dataPackage.endDate).toISOString());
    formData.append("ClonedUploads", dataPackage.clonedUploads != null ? JSON.stringify(dataPackage.clonedUploads) : null);
    formData.append("Notes", dataPackage.notes);

    await certificateStore.store(formData, { "Content-Type": "multipart/form-data" });
  }

  const isValid = () =>
    name != "" &&
    //selectedCompany !== "" &&
    search != "";

  function performSearch() {
    setValidationCheck(true);
    if (!isValid()) return;
    setSubmittedSearch(search);
    setSubmittedCompany(selectedCompany);
  }

  function handleEnter(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      performSearch();
    }
  }

  return (
    <>
      <Row>
        <Col sm="6">
          <h3 className="card-title">
            {existingCertificate ? (
              <FormattedMessage id="certificates.edit_declaration" defaultMessage="Edit a Declaration" />
            ) : (
              <FormattedMessage id="certificates.declaration" defaultMessage="Create a Declaration" />
            )}
          </h3>
        </Col>
        {!existingCertificate && (
          <Col sm="6">
            <div className="form-group row">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                <FormattedMessage id="app.name" defaultMessage="Name" />
              </label>
              <div className="col-sm-2">
                <select className="form-control" onChange={(e) => setTypeOfCertificate(parseInt(e.target.value))}>
                  <option value="13">DoC</option>
                  {/* <option value="167">DoP</option> */}
                  <option value="166">DoI</option>
                </select>
              </div>

              <div className="col-sm-8">
                <input
                  type="text"
                  className={`form-control ${validationCheck && name == "" ? "is-invalid" : ""}`}
                  id="name"
                  onKeyUp={(e) => setName(e.target.value)}
                  maxLength={100}
                />
              </div>
            </div>
            {typeOfCertificate == 13 && (
              <div className="row">
                <div className="col-sm-2"></div>
                <div className="col-sm-10">
                  <div style={{ paddingLeft: 20 }}>
                    <input className="form-check-input" type="checkbox" id={`ukca`} checked={isUKCA} onChange={(e) => setIsUKCA(e.target.checked)} />
                    <label className="form-check-label" htmlFor={`ukca`}>
                      <FormattedMessage id="certificates.ukca" defaultMessage="UKCA" />
                    </label>
                  </div>
                </div>
              </div>
            )}
          </Col>
        )}
      </Row>
      <Row>
        <Col className="mt-3">
          {!existingCertificate && (
            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    <FormattedMessage id="app.search" defaultMessage="Search" />
                  </CardHeader>
                  <CardBody>
                    <FormGroup row className="my-0">
                      <Label sm={6}>
                        <FormattedMessage id="datos_placa.company" defaultMessage="Company" />
                      </Label>
                      <Col sm={6}>
                        <Input
                          type="select"
                          //className={validationCheck && selectedCompany === "" ? "is-invalid" : ""}
                          value={selectedCompany}
                          onChange={(e) => setSelectedCompany(parseInt(e.target.value))}
                        >
                          <option value="">{intl.formatMessage({ id: "product_information.select_an_option", defaultMessage: "Please select an option" })}</option>
                          {companies.map((a) => (
                            <option key={a.keyCompanyManufacturer} value={a.keyCompanyManufacturer}>
                              {a.companyManufacturer}
                            </option>
                          ))}
                        </Input>
                      </Col>
                    </FormGroup>
                    <FormGroup row className="my-0">
                      <Label sm={6}>
                        <FormattedMessage id="certificates.search" defaultMessage="Series / Product search" />
                      </Label>
                      <Col sm={6}>
                        <Input
                          type="text"
                          onKeyDown={handleEnter}
                          className={validationCheck && search == "" ? "is-invalid" : ""}
                          onKeyUp={(e) => setSearch(e.target.value)}
                        ></Input>
                      </Col>
                    </FormGroup>
                  </CardBody>

                  <CardFooter>
                    <Button className="btn btn-outline-primary" onClick={performSearch}>
                      <FormattedMessage id="app.search" defaultMessage="Search" />
                    </Button>
                  </CardFooter>
                </Card>
              </Col>
            </Row>
          )}
          {existingCertificate && <ExistingCertificateSummary data={existingCertificate}></ExistingCertificateSummary>}
          <Row>
            <Col>
              <CertificateSeriesProductSearchResults
                search={submittedSearch}
                keyCompany={submittedCompany}
                saveCertificate={saveCertificate}
                updateCertificate={updateCertificate}
                previewCertificate={previewCertificate}
                history={history}
                cloneData={cloneData}
                existingCertificate={existingCertificate}
              ></CertificateSeriesProductSearchResults>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export default CertificateProductSelection;
